import Handsontable from 'handsontable/base';

/**
 * Returns the Handsontable root DOM element for a HOT instance.
 */
const getHotRootContainerFromHotInstance = (hotInstance: Handsontable): HTMLDivElement | null =>
    hotInstance.rootContainer as HTMLDivElement;

/**
 * Returns the `.HotTable` wrapper element for a HOT instance.
 */
export const getHotTableElementFromHotInstance = (hotInstance: Handsontable): HTMLDivElement | null =>
    getHotRootContainerFromHotInstance(hotInstance)?.parentElement as HTMLDivElement;

/**
 * Returns the outer Milanote table element for a HOT instance.
 */
export const getTableElementFromHotInstance = (hotInstance: Handsontable): HTMLDivElement | null =>
    getHotTableElementFromHotInstance(hotInstance)?.parentElement as HTMLDivElement;
